import VolatilityMessageComponent from "../layout/VolatilityMessageComponent";


const VolatilityMessageList = () => {

  return (
      <VolatilityMessageComponent type="ONETIME" />
  );
};
export default VolatilityMessageList;
